import * as React from 'react';
import { IPaymentJournal } from '../Entities';
import { Table, Button } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import DateTimeView from '../../localDate/DateTimeView';

interface IProps {
    list: IPaymentJournal[];
    view: (id: number) => void;
}

const PaymentJournalList = (props: IProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('payment-journal/list/table-header/id')}</th>
                    <th>{Translate('payment-journal/list/table-header/created-date')}</th>
                    <th>{Translate('payment-journal/list/table-header/number-of-payments')}</th>
                    <th>{Translate('payment-journal/list/table-header/bank-account')}</th>
                    <th>{Translate('payment-journal/list/table-header/accounts-receivable')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.list.map((x: IPaymentJournal, index: number) => (
                    <tr key={index}>
                        <td>{x.id}</td>
                        <td>
                            <DateTimeView dateTime={x.createdDate} format="LL" />
                        </td>
                        <td>{x.numberOfPayments}</td>
                        <td>{x.bankAccount}</td>
                        <td>{x.accountsReceivable}</td>
                        <td>
                            <Button
                                className="pull-right"
                                onClick={() => props.view(x.id)}
                                bsSize="sm"
                                bsStyle="info"
                            >
                                <i className="material-icons">pageview </i>
                                {Translate('payment-journal/list/table/view/button')}
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default PaymentJournalList;
